interface IQuillEditorScope extends ng.IScope {
    onContentChanged?: any;
    placeholder?: string;
    readOnly?: boolean;
    onSelectionChanged?: any;
    onEditorCreated?: any;
    modules?: any;
}

function quillEditor(): ng.IDirective {
    return {
        restrict: 'E',
        template: '<div class="quill-editor-container"><div class="quill-editor"></div></div>',
        controllerAs: 'quillDirectiveVm',
        require: '?ngModel',
        scope: {
            onContentChanged: '&?',
            placeholder: '@?',
            readOnly: '=?',
            onSelectionChanged: '&?',
            onEditorCreated: '&?',
            modules: '=?'
        },
        link: (
            scope: IQuillEditorScope,
            element: ng.IAugmentedJQuery,
            attributes: ng.IAttributes,
            ngModel: ng.INgModelController
        ): void => {
            if (!ngModel) return;

            const options = {
                theme: 'snow',
                bounds: 'self',
                placeholder: scope.placeholder || 'Insert text here ...',
                readOnly: scope.readOnly || false,
                modules: scope.modules || {
                    clipboard: {
                        matchers: [
                            [Node.ELEMENT_NODE, (node, delta) => {
                                delta.ops.forEach(op => {
                                    if (op.attributes && op.attributes.background) {
                                        op.attributes.background = 'transparent';
                                        op.attributes.color = 'black';
                                    }
                                });
                                return delta;
                            }]
                        ]
                    },
                    toolbar: [
                        [{ header: [1, 2, 3, false] }],
                        ['bold', 'italic', 'underline', 'strike'],
                        [{ list: 'ordered' }, { list: 'bullet' }],
                        ['link']
                    ]
                }
            };
            const Link = Quill.import('formats/link');
            Link.sanitize = function (url) {
                if (!url.startsWith("http")) {
                    url = "http://" + url;
                }
                return url;
            };
            Quill.register(Link, true);

            const editorEl = element[0].querySelector('.quill-editor');
            const quill = new Quill(editorEl, options);

            if (!!scope.onEditorCreated) {
                scope.onEditorCreated({ editor: quill });
            }

            let internalUpdate = false;
            ngModel.$render = function () {
                if (internalUpdate) return;
                const content = ngModel.$viewValue || '';
                quill.root.innerHTML = content;
            };

            quill.on('text-change', function () {
                internalUpdate = true;
                let html = quill.root.innerHTML;
                if (html === '<p><br></p>' || html.trim() === '') {
                    html = '';
                }
                ngModel.$setViewValue(html);
                internalUpdate = false;
                if (!!scope.onContentChanged) {
                    scope.onContentChanged({
                        editor: quill,
                        html: quill.root.innerHTML,
                        text: quill.getText()
                    });
                }
            });

            quill.on('selection-change', (range, oldRange, source) => {
                if (!!scope.onSelectionChanged) {
                    scope.onSelectionChanged({
                        editor: quill,
                        range: range,
                        oldRange: oldRange,
                        source: source
                    });
                }
            });
        }
    };
}

angular.module('eCareVault.common.directives').directive('ecvQuillEditor', quillEditor);
